export const heroHome = () => {
  if (document.querySelector('.hero-home')) {

    window.lenis = lenis;
    console.log(document.querySelector('.hero-home .button'))
    document.querySelector('.hero-home .button')?.addEventListener('click', (e) => {
      e.preventDefault()
      const scrollAmount = window.innerHeight;
      lenis.scrollTo(scrollAmount, {
        duration: 1,
        easing: (t) => 1 - Math.pow(1 - t, 3),
      });
    });
  }


}